<div class="cap-alerts">
  <div class="cap-alerts-dialog-header">
    <mat-icon
      class="integration-logo"
      svgIcon="integration-cap-alerts"
      aria-hidden="true"
    ></mat-icon>
    <h3 class="cap-alerts-dialog-header-title">CAP Alerts</h3>
    <button
      type="button"
      mat-icon-button
      class="cap-alerts__close-button"
      data-close="modal"
      aria-label="Click to close this modal"
      (click)="cancel()"
    >
      <mat-icon svgIcon="close" />
    </button>
  </div>

  <div
    class="cap-alerts-spinner-host"
    rvSpinner="cap-alerts-loading"
    [rvShowSpinner]="capAlertsService.isLoading"
  >
    <mat-dialog-content>
      <div class="cap-alerts-main-content">
        <div class="cap-alerts-main-content-body">
          <div
            class="tw-max-w-[800px] tw-mx-auto tw-flex tw-flex-col tw-gap-[16px]"
          >
            @if (capAlertsService.apiError) {
              <div
                id="errorBox"
                class="alert alert-danger cap-alerts-status-message"
                role="alert"
              >
                <div class="tw-flex tw-items-center tw-gap-[8px] tw-min-w-0">
                  <mat-icon
                    aria-hidden="true"
                    svgIcon="error-filled"
                    class="small tw-text-red-600"
                  ></mat-icon>
                  <span class="tw-min-w-0"
                    ><strong>{{ capAlertsService.errorMessage }}</strong>
                    {{ capAlertsService.apiError }}
                  </span>
                </div>
                <button
                  type="button"
                  mat-icon-button
                  class="cap-alerts-status-message__dismiss"
                  aria-label="Dismiss error"
                  (click)="dismissError()"
                >
                  <mat-icon class="small" svgIcon="close" aria-hidden="true" />
                </button>
              </div>
            }

            @if (
              capAlertsService.missingTemplate &&
              capAlertsService.alertSettings.templateProductCode === ''
            ) {
              <div class="alert alert-warning cap-alerts-status-message">
                <div class="tw-flex tw-items-center tw-gap-[8px]">
                  <mat-icon
                    aria-hidden="true"
                    svgIcon="warning-filled"
                    class="small tw-text-yellow-500"
                  ></mat-icon>
                  {{ WARNING_MISSING_TEMPLATE }}
                </div>
              </div>
            }

            <div class="cap-alerts-content-section">
              <h2 class="cap-alerts-content-section-heading">
                Enter your CAP provider's credentials
              </h2>

              <ul class="cap-alerts-authentication-grid">
                <li class="cap-alerts-authentication-item">
                  <label class="control-label" for="usernameInput">Name</label>
                  <input
                    id="usernameInput"
                    type="text"
                    class="form-control"
                    [(ngModel)]="capAlertsService.alertSettings.userName"
                    [disabled]="fieldsDisabled"
                    placeholder="Enter name"
                  />
                </li>

                <li class="cap-alerts-authentication-item">
                  <label class="control-label" for="passwordInput"
                    >Password</label
                  >
                  <input
                    id="passwordInput"
                    type="password"
                    class="form-control"
                    [(ngModel)]="capAlertsService.alertSettings.password"
                    [disabled]="fieldsDisabled"
                    placeholder="Enter password"
                  />
                </li>
              </ul>

              <h2 class="cap-alerts-content-section-heading">
                Paste address into your CAP provider
              </h2>

              <p class="cap-alerts-content-section-notice">
                Copy this unique address and paste it directly inside your
                third-party CAP provider's outgoing configuration screen.
              </p>

              <div class="flex-row space-between py-2">
                <div class="input-group tw-w-full tw-mr-[8px]">
                  <input
                    id="webserviceUrlInput"
                    type="text"
                    class="form-control tw-bg-gray-50 tw-text-gray-500 tw-w-full tw-pointer-events-none"
                    tabindex="-1"
                    [ngModel]="alertUrl"
                    [readonly]="true"
                    placeholder="Enter URL"
                  />

                  <span class="input-group-addon !tw-border-gray-300">
                    <button
                      mat-icon-button
                      [focus-outline]="2"
                      type="button"
                      class="tw-w-[20px] tw-h-[20px]"
                      aria-label="Copy alert URL"
                      (click)="copyAlertUrl()"
                      [disabled]="fieldsDisabled"
                      matTooltip="Copy"
                      matTooltipClass="menu-tooltip"
                    >
                      <mat-icon
                        svgIcon="copy"
                        class="tw-text-gray-700"
                        aria-hidden="true"
                      />
                    </button>
                  </span>
                </div>

                <button
                  matButton="outlined"
                  id="urlResetButton"
                  class="button-width--fit button-role--danger"
                  type="button"
                  (click)="resetAlertUrl()"
                  [disabled]="fieldsDisabled"
                >
                  Reset URL
                </button>
              </div>
            </div>

            <div class="cap-alerts-content-section">
              <h2 class="cap-alerts-content-section-heading">
                Choose a template
              </h2>
              <ul
                class="template-list cap-alerts-template-selection-grid"
                [shown]="templates && templates.length > 0"
              >
                @for (template of templates; track template; let i = $index) {
                  <li
                    class="cap-alerts-template-selection"
                    [class.cap-alerts-template-selection-selected]="
                      capAlertsService.alertSettings.templateProductCode ===
                      template.productCode
                    "
                    [class.cap-alerts-template-selection-disabled]="
                      capAlertsService.alertSettings.templateProductCode ===
                        template.productCode && fieldsDisabled
                    "
                    (click)="setTemplate(template.productCode)"
                  >
                    <div class="template-image mb-3">
                      @if (template.imageUrl) {
                        <img
                          loading="lazy"
                          [src]="template.imageUrl"
                          attr.aria-describedby="alert-template-{{ i }}-label"
                          alt="{{ template.imageAlt || template.name }}"
                        />
                      }
                    </div>
                    <div class="cap-alerts-template-selection-option">
                      <mat-checkbox
                        [class.appear-enabled]="!fieldsDisabled"
                        [ngModel]="
                          capAlertsService.alertSettings.templateProductCode ===
                          template.productCode
                        "
                        [disabled]="
                          fieldsDisabled ||
                          capAlertsService.alertSettings.templateProductCode ===
                            template.productCode
                        "
                        (ngModelChange)="setTemplate(template.productCode)"
                        aria-labelledby="alert-template-{{ i }}-label"
                        [ariaChecked]="
                          capAlertsService.alertSettings.templateProductCode ===
                          template.productCode
                        "
                        ariaCheckedElementId="alert-template-{{ i }}-input"
                      />
                      <label
                        class="u_clickable"
                        for="alert-template-{{ i }}-input"
                        id="alert-template-{{ i }}-label"
                        >{{ template.name }}</label
                      >
                    </div>
                  </li>
                }
              </ul>

              @if (
                (capAlertsService.alertSettings.presentationId &&
                  !capAlertsService.alertSettings.templateProductCode) ||
                userStateService.isRiseAdmin()
              ) {
                <div
                  class="tw-flex tw-flex-row tw-items-center tw-space-between cap-alerts-template-selection cap-alerts-custom-presentation"
                  [class.cap-alerts-template-selection-selected]="
                    isCustomPresentationSelected
                  "
                  [class.tw-pointer-events-none]="fieldsDisabled"
                  (click)="handleCustomPresentationSelection($event)"
                >
                  <mat-checkbox
                    id="custom-presentation"
                    [checked]="isCustomPresentationSelected"
                    [disabled]="fieldsDisabled"
                    (change)="handleCustomPresentationSelection($event)"
                    aria-labelledby="custom-presentation-label"
                    [ariaChecked]="isCustomPresentationSelected"
                    ariaCheckedElementId="custom-presentation-input"
                  />
                  <label
                    class="u_clickable mb-0 tw-ml-[5px]"
                    id="custom-presentation-label"
                  >
                    {{
                      capAlertsService.alertSettings.presentationName ||
                        'Custom Presentation'
                    }}
                  </label>
                  <streamline-icon
                    aria-hidden="true"
                    [shown]="
                      userStateService.isRiseAdmin() &&
                      !capAlertsService.alertSettings.presentationId
                    "
                    [width]="16"
                    [height]="16"
                    name="riseLogo"
                    class="flex-row tw-ml-[12px] rise-green"
                  ></streamline-icon>
                  <div class="tw-flex-grow"></div>
                  <div class="tw-bg-white tw-rounded-[6px] tw-ml-6">
                    <button
                      matButton="outlined"
                      (click)="capAlertsService.changePresentation()"
                      [disabled]="fieldsDisabled"
                      [shown]="
                        userStateService.isRiseAdmin() &&
                        capAlertsService.alertSettings.presentationId
                      "
                      class="button-width--fit rise-admin-only"
                    >
                      Change
                    </button>
                  </div>
                </div>
              }
            </div>

            <div
              *requireAccess="'display:fullAccess'"
              class="cap-alerts-content-section"
            >
              <div
                class="flex-row tw-items-center tw-justify-between tw-mb-[10px]"
              >
                <h2 class="cap-alerts-content-section-heading">
                  Display options
                </h2>
              </div>

              <div class="cap-alerts-content-section-subsection">
                <span id="enable-audio-label">Play alert sound</span>

                <div class="mt-2 flex-row align-center">
                  <mat-slide-toggle
                    id="enable-audio"
                    [(ngModel)]="capAlertsService.alertSettings.enableAudio"
                    [disabled]="fieldsDisabled"
                    aria-labelledby="enable-audio-label"
                  >
                  </mat-slide-toggle>
                </div>
              </div>

              <div class="cap-alerts-content-section-subsection">
                <span>Alert Content</span>

                <div class="cap-alerts-alert-content-list">
                  @for (item of capAlertsService.textFieldsValues; track item) {
                    <div class="cap-alerts-alert-content-list-item">
                      <mat-checkbox
                        id="textFieldsCheckbox-{{ item.key }}"
                        (change)="
                          setCheckboxList(
                            'textFields',
                            item.key,
                            $event.checked
                          )
                        "
                        [checked]="getCheckboxList('textFields', item.key)"
                        [disabled]="fieldsDisabled"
                        aria-labelledby="textFieldsCheckbox-{{
                          item.key
                        }}-label"
                        [ariaChecked]="getCheckboxList('textFields', item.key)"
                        ariaCheckedElementId="textFieldsCheckbox-{{
                          item.key
                        }}-input"
                        class="tw-mr-[16px]"
                      />
                      <label
                        class="u_nowrap mb-0 u_clickable"
                        for="textFieldsCheckbox-{{ item.key }}-input"
                        id="textFieldsCheckbox-{{ item.key }}-label"
                        >{{ item.label }}</label
                      >
                    </div>
                  }
                </div>
              </div>
            </div>

            <div class="cap-alerts-content-section">
              <div
                class="flex-row tw-items-start tw-justify-between tw-mb-[10px]"
              >
                <h2 class="cap-alerts-content-section-heading">Distribution</h2>
              </div>

              <div class="cap-alerts-content-section-subsection">
                <distribution-selector
                  [(distribution)]="capAlertsService.alertSettings.distribution"
                  [(distributeToAll)]="
                    capAlertsService.alertSettings.distributeToAll
                  "
                  [(subcompanyDistribution)]="
                    capAlertsService.alertSettings.subcompanyDistribution
                  "
                  [(distributeToSubcompanies)]="
                    capAlertsService.alertSettings.distributeToSubcompanies
                  "
                  [enableSubcompanies]="true"
                  [(subcompanyDistributeToAll)]="
                    capAlertsService.alertSettings.subcompanyDistributeToAll
                  "
                  [enableSubcompanyDistributeToAll]="true"
                  [enableFeatureCheck]="false"
                  [readonly]="fieldsDisabled"
                  inputId="-alerts"
                  [showLabel]="false"
                >
                </distribution-selector>
              </div>
            </div>

            <div class="cap-alerts-content-section">
              <div class="cap-alerts-content-section-header">
                <h2
                  class="cap-alerts-content-section-heading"
                  id="default-expiry-label"
                >
                  Default Expiry
                </h2>
              </div>
              <div
                class="cap-alerts-content-section-subsection cap-alerts-content-section-subsection__clear cap-alerts-content-section-subsection__expiry"
              >
                <div id="default-expiry-label-description">
                  Fallback duration before alerts clear and scheduled content
                  resumes
                </div>

                <div class="input-group">
                  <input
                    id="defaultExpiryInput"
                    type="number"
                    role="spinbutton"
                    class="form-control tw-w-[100px]"
                    [(ngModel)]="capAlertsService.alertSettings.defaultExpiry"
                    [disabled]="fieldsDisabled"
                    [attr.aria-valuenow]="
                      capAlertsService.alertSettings.defaultExpiry
                    "
                    min="0"
                    aria-valuemin="0"
                    [attr.aria-invalid]="
                      capAlertsService.alertSettings.defaultExpiry < 0
                    "
                    aria-labelledby="default-expiry-label"
                    aria-describedby="default-expiry-label-description"
                    (input)="onDefaultExpiryInput($event)"
                    (keydown)="onDefaultExpiryKeydown($event)"
                  />
                  <span class="input-group-addon">
                    <div class="u_nowrap">Minutes</div>
                  </span>
                </div>
              </div>
            </div>

            <div class="cap-alerts-content-section">
              <mat-expansion-panel
                class="expansion-panel-flush mat-elevation-z0"
                [(expanded)]="showFilters"
              >
                <mat-expansion-panel-header
                  class="tw-pl-0 tw-pr-[5px] !tw-h-[20px]"
                >
                  <h2 class="cap-alerts-content-section-heading mb-0">
                    Filters
                  </h2>
                </mat-expansion-panel-header>

                <div
                  class="panel-body tw-pl-0 tw-pr-[1px] tw-mt-[16px]"
                  id="filtersContainer"
                >
                  <div class="row mb-2">
                    <div
                      class="form-group col-xs-12 col-sm-4"
                      id="senderContainer"
                    >
                      <label class="control-label" for="allowedSenders"
                        >Sender</label
                      >
                      <input
                        id="allowedSenders"
                        type="text"
                        class="form-control"
                        [(ngModel)]="allowedSendersCsv"
                        [disabled]="fieldsDisabled"
                        (ngModelChange)="
                          parseCsvList(allowedSendersCsv, 'allowedSenders')
                        "
                      />
                    </div>
                    <!--form-group-->
                    <div
                      class="form-group col-xs-12 col-sm-4"
                      id="handlingContainer"
                    >
                      <label class="control-label" for="allowedHandlingCodes"
                        >Handling</label
                      >
                      <input
                        id="allowedHandlingCodes"
                        type="text"
                        class="form-control"
                        [(ngModel)]="allowedHandlingCodesCsv"
                        [disabled]="fieldsDisabled"
                        (ngModelChange)="
                          parseCsvList(
                            allowedHandlingCodesCsv,
                            'allowedHandlingCodes'
                          )
                        "
                      />
                    </div>
                    <!--form-group-->
                    <div
                      class="form-group col-xs-12 col-sm-4"
                      id="codeContainer"
                    >
                      <label class="control-label" for="allowedEventCodes"
                        >Code</label
                      >
                      <input
                        id="allowedEventCodes"
                        type="text"
                        class="form-control"
                        [(ngModel)]="allowedEventCodesCsv"
                        [disabled]="fieldsDisabled"
                        (ngModelChange)="
                          parseCsvList(
                            allowedEventCodesCsv,
                            'allowedEventCodes'
                          )
                        "
                      />
                    </div>
                    <!--form-group-->
                  </div>
                  <div class="row">
                    <div class="col-xs-6 col-sm-3 mb-3">
                      <label class="control-label" id="statusLabel"
                        >Status</label
                      >
                      @for (
                        item of capAlertsService.allowedStatusesValues;
                        track item
                      ) {
                        <div>
                          <mat-checkbox
                            id="statusesCheckbox-{{ item.key }}"
                            (ngModelChange)="
                              setCheckboxList(
                                'allowedStatuses',
                                item.key,
                                $event
                              )
                            "
                            [ngModel]="
                              getCheckboxList('allowedStatuses', item.key)
                            "
                            [disabled]="fieldsDisabled"
                            aria-labelledby="statusesCheckbox-{{
                              item.key
                            }}-label"
                            [ariaChecked]="
                              getCheckboxList('allowedStatuses', item.key)
                            "
                            ariaCheckedElementId="statusesCheckbox-{{
                              item.key
                            }}-input"
                          />
                          <label
                            class="font-weight-normal u_nowrap mb-0 u_clickable"
                            for="statusesCheckbox-{{ item.key }}-input"
                            id="statusesCheckbox-{{ item.key }}-label"
                            >{{ item.label }}</label
                          >
                        </div>
                      }
                    </div>
                    <div class="col-xs-6 col-sm-3 mb-3">
                      <label class="control-label" id="urgencyLabel"
                        >Urgency</label
                      >
                      @for (
                        item of capAlertsService.allowedUrgenciesValues;
                        track item
                      ) {
                        <div>
                          <mat-checkbox
                            id="urgenciesCheckbox-{{ item.key }}"
                            (ngModelChange)="
                              setCheckboxList(
                                'allowedUrgencies',
                                item.key,
                                $event
                              )
                            "
                            [ngModel]="
                              getCheckboxList('allowedUrgencies', item.key)
                            "
                            [disabled]="fieldsDisabled"
                            aria-labelledby="urgenciesCheckbox-{{
                              item.key
                            }}-label"
                            [ariaChecked]="
                              getCheckboxList('allowedUrgencies', item.key)
                            "
                            ariaCheckedElementId="urgenciesCheckbox-{{
                              item.key
                            }}-input"
                          />
                          <label
                            class="font-weight-normal u_nowrap mb-0 u_clickable"
                            for="urgenciesCheckbox-{{ item.key }}-input"
                            id="urgenciesCheckbox-{{ item.key }}-label"
                            >{{ item.label }}</label
                          >
                        </div>
                      }
                    </div>
                    <div class="col-xs-6 col-sm-3 mb-3">
                      <label class="control-label" id="severityLabel"
                        >Severity</label
                      >
                      @for (
                        item of capAlertsService.allowedSeveritiesValues;
                        track item
                      ) {
                        <div>
                          <mat-checkbox
                            id="severitiesCheckbox-{{ item.key }}"
                            (ngModelChange)="
                              setCheckboxList(
                                'allowedSeverities',
                                item.key,
                                $event
                              )
                            "
                            [ngModel]="
                              getCheckboxList('allowedSeverities', item.key)
                            "
                            [disabled]="fieldsDisabled"
                            aria-labelledby="severitiesCheckbox-{{
                              item.key
                            }}-label"
                            [ariaChecked]="
                              getCheckboxList('allowedSeverities', item.key)
                            "
                            ariaCheckedElementId="severitiesCheckbox-{{
                              item.key
                            }}-input"
                          />
                          <label
                            class="font-weight-normal u_nowrap mb-0 u_clickable"
                            for="severitiesCheckbox-{{ item.key }}-input"
                            id="severitiesCheckbox-{{ item.key }}-label"
                            >{{ item.label }}</label
                          >
                        </div>
                      }
                    </div>
                    <div class="col-xs-6 col-sm-3 mb-3">
                      <label class="control-label" id="certaintyLabel"
                        >Certainty</label
                      >
                      @for (
                        item of capAlertsService.allowedCertaintiesValues;
                        track item
                      ) {
                        <div>
                          <mat-checkbox
                            id="certaintiesCheckbox-{{ item.key }}"
                            (ngModelChange)="
                              setCheckboxList(
                                'allowedCertainties',
                                item.key,
                                $event
                              )
                            "
                            [ngModel]="
                              getCheckboxList('allowedCertainties', item.key)
                            "
                            [disabled]="fieldsDisabled"
                            aria-labelledby="certaintiesCheckbox-{{
                              item.key
                            }}-label"
                            [ariaChecked]="
                              getCheckboxList('allowedCertainties', item.key)
                            "
                            ariaCheckedElementId="certaintiesCheckbox-{{
                              item.key
                            }}-input"
                          />
                          <label
                            class="font-weight-normal u_nowrap mb-0 u_clickable"
                            for="certaintiesCheckbox-{{ item.key }}-input"
                            id="certaintiesCheckbox-{{ item.key }}-label"
                            >{{ item.label }}</label
                          >
                        </div>
                      }
                    </div>
                  </div>
                  <br />
                  <label class="control-label" id="categoryLabel"
                    >Category</label
                  >
                  <div class="row">
                    @for (
                      item of capAlertsService.allowedCategoriesValues;
                      track item
                    ) {
                      <div class="col-xs-12 col-sm-3 flex-row align-start">
                        <mat-checkbox
                          id="categoriesCheckbox-{{ item.key }}"
                          (ngModelChange)="
                            setCheckboxList(
                              'allowedCategories',
                              item.key,
                              $event
                            )
                          "
                          [ngModel]="
                            getCheckboxList('allowedCategories', item.key)
                          "
                          [disabled]="fieldsDisabled"
                          aria-labelledby="categoriesCheckbox-{{
                            item.key
                          }}-label"
                          [ariaChecked]="
                            getCheckboxList('allowedCategories', item.key)
                          "
                          ariaCheckedElementId="categoriesCheckbox-{{
                            item.key
                          }}-input"
                        />
                        <label
                          class="font-weight-normal mt-2 mb-0 u_clickable text-break-spaces"
                          for="categoriesCheckbox-{{ item.key }}-input"
                          id="categoriesCheckbox-{{ item.key }}-label"
                          >{{ item.label }}</label
                        >
                      </div>
                    }
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
  </div>

  @if (showCommonActions) {
    <mat-dialog-actions class="cap-alerts-dialog-footer">
      <common-actions
        [actions]="actions"
        [saving]="saving"
        [changeDate]="capAlertsService.changeDate"
        [changedBy]="capAlertsService.changedBy"
      >
      </common-actions>
    </mat-dialog-actions>
  }
</div>
